import { Link } from "react-router-dom";
import { Users, Briefcase, Snowflake, ArrowRight, Check } from "lucide-react";
import Seo from "@/components/Seo";
import Breadcrumbs from "@/components/layout/Breadcrumbs";
import CtaBand from "@/components/sections/CtaBand";
import { useVehicles } from "@/hooks/usePublicData";

export default function Fleet() {
  const { data: vehicles = [] } = useVehicles();
  return (
    <>
      <Seo title="Our Taxi Fleet | Sedan, SUV & Tempo Traveller | Chouhan Taxi Service"
        description="Choose from our clean, air-conditioned fleet — sedans, SUVs, premium SUVs and tempo travellers — for comfortable taxi travel across Rajasthan."
        path="/fleet" />
      <Breadcrumbs items={[{ label: "Fleet" }]} />
      <section className="pt-8">
        <div className="container-x max-w-3xl">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-extrabold text-navy-heading leading-tight">Our Taxi Fleet</h1>
          <p className="mt-4 text-slate-600 leading-relaxed">Travel in comfort with our well-maintained, air-conditioned vehicles. From economical sedans for couples to spacious tempo travellers for large groups, we have the right car for your Rajasthan journey.</p>
        </div>
      </section>
      <section className="section-pad pt-10">
        <div className="container-x">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {vehicles.map((v) => (
              <div key={v.id} className="bg-white rounded-2xl overflow-hidden border border-slate-100 shadow-sm card-hover" data-testid={`fleet-card-${v.category}`}>
                <div className="h-48 overflow-hidden bg-slate-100"><img src={v.image} alt={`${v.name} taxi — ${v.examples || ""}`} className="w-full h-full object-cover" /></div>
                <div className="p-6">
                  <h2 className="font-heading font-bold text-navy-heading text-xl">{v.name}</h2>
                  {v.examples && <p className="text-xs text-slate-400 mt-1">{v.examples}</p>}
                  <div className="mt-4 space-y-2 text-sm text-slate-600">
                    <div className="flex items-center gap-2"><Users className="w-4 h-4 text-brand" /> {v.seating}</div>
                    <div className="flex items-center gap-2"><Briefcase className="w-4 h-4 text-brand" /> {v.luggage}</div>
                    <div className="flex items-center gap-2"><Snowflake className="w-4 h-4 text-brand" /> {v.ac ? "Air Conditioned" : "Non-AC"}</div>
                  </div>
                  <div className="mt-3 flex items-start gap-2 text-xs text-slate-500"><Check className="w-4 h-4 text-brand shrink-0" /> {v.suitable_for}</div>
                  <Link to="/book-taxi" className="mt-5 block text-center bg-brand text-white font-semibold text-sm py-2.5 rounded-full hover:bg-royal transition-colors" data-testid={`fleet-book-${v.category}`}>Book Now</Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
